<template>
  <div class="relative block w-full">
    <div class="w-full bottom-0">
      <img class="2xl:hidden" :src="FooterImage" alt="Footer Image" />
      <img class="max-2xl:hidden" :src="SimpleFooterImage" alt="Footer Image" />
      <footer
        class="flex md:flex-row max-md:flex-col justify-between bg-[#123A35] text-white px-10 pb-12"
      >
        <div class="flex flex-col font-alexandria">
          <!-- Brand -->
          <div class="cursor-pointer" @click="router.push('landing')">
            <div class="inline-block">
              <p class="hover:scale-110 transition-transform text-3xl mb-4">
                Scu4<span class="text-yellow">CHANGE</span>
              </p>
            </div>
          </div>

          <p class="mb-8 font-extralight">
            Empowering teachers to tackle complex challenges<br />together.
          </p>

          <!-- Links -->
          <div class="flex sm:flex-row max-sm:flex-col font-roboto max-md:mb-8">
            <button
              @click="jumpTo('#contact')"
              class="hover:scale-110 transition-transform cursor-pointer max-sm:text-left"
            >
              Contact
            </button>
            <button
              @click="jumpTo('#license')"
              class="hover:scale-110 transition-transform cursor-pointer sm:ml-8 max-sm:text-left"
            >
              License
            </button>
            <button
              @click="jumpTo('#universalaccess')"
              class="hover:scale-110 transition-transform cursor-pointer sm:ml-8 max-sm:text-left"
            >
              Universal Access
            </button>
            <button
              @click="jumpTo('#privacy')"
              class="hover:scale-110 transition-transform cursor-pointer sm:ml-8 max-sm:text-left"
            >
              Privacy
            </button>

            <button
              @click="jumpTo('#disclaimer')"
              class="hover:scale-110 transition-transform cursor-pointer sm:ml-8 max-sm:text-left"
            >
              Disclaimer
            </button>
          </div>
        </div>
        <button
          @click="openLink('https://nettskjema.no/a/teachers4change')"
          class="flex flex-row font-alexandria border-4 border-[#042E2C] rounded-full items-center self-start cursor-pointer shadow-lg whitespace-nowrap"
        >
          <span class="px-6">Send us your feedback!</span>
          <span class="bg-[#042E2C] p-4 rounded-full">
            <img class="w-4" :src="rightArrow" alt="right arrow" />
          </span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script setup lang="ts">
import FooterImage from '@/assets/footer.png'
import SimpleFooterImage from '@/assets/footer-simple.svg'
import rightArrow from '@/assets/rightArrowWhite.svg'
import { useRouter } from 'vue-router'
const router = useRouter()

const openLink = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer')
}

function jumpTo(hash: string) {
  const locale = localStorage.getItem('user-locale') || 'en'
  router.push({ path: `/${locale}/compliance`, hash })
}
</script>

<style scoped></style>
